import { render } from "./OneCoupon.vue?vue&type=template&id=b6371830&scoped=true&ts=true"
import script from "./OneCoupon.vue?vue&type=script&lang=ts"
export * from "./OneCoupon.vue?vue&type=script&lang=ts"

import "./OneCoupon.vue?vue&type=style&index=0&id=b6371830&scoped=true&lang=scss"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6371830"]])

export default __exports__